import { Clipboard } from '@angular/cdk/clipboard';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faAddressBook, faCopy } from '@fortawesome/free-regular-svg-icons';
import {
  IconDefinition,
  faAddressCard,
  faBookOpenReader,
  faBus,
  faBusinessTime,
  faCheck,
  faCheckToSlot,
  faChevronDown,
  faChevronUp,
  faCircleExclamation,
  faEdit,
  faEnvelope,
  faFile,
  faFilePen,
  faFileSignature,
  faGraduationCap,
  faHand,
  faHouseUser,
  faLanguage,
  faLocationDot,
  faMagnifyingGlassChart,
  faNotesMedical,
  faPen,
  faSchool,
  faSquare,
  faSuitcaseMedical,
  faTriangleExclamation,
  faUniversalAccess,
  faUserGraduate,
  faUserNurse,
  faUsers,
  faUsersBetweenLines,
} from '@fortawesome/free-solid-svg-icons';
import { PopupRef, PopupService } from '@progress/kendo-angular-popup';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { SVGIcon, pencilIcon, xIcon } from '@progress/kendo-svg-icons';
import * as _ from 'lodash';
import { head } from 'lodash';
import { BehaviorSubject, combineLatest, filter, take, timer } from 'rxjs';
import { ActionsResponse } from 'src/app/modules/dashboard/interface/actions-response';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { RoutesConstantService } from 'src/app/services/routes-constant.service';
import { StudentService } from 'src/app/services/student.service';
import { CustomActionsComponent } from 'src/app/shared/components/custom-actions/custom-actions.component';
import { MeetingType } from 'src/app/shared/enums/meeting-type';
import { DropdownOption } from 'src/app/shared/interfaces/dropdown-option';
import { MeetingRole } from 'src/app/shared/interfaces/meeting-role';
import {
  ParentInfo,
  ParentsInfo,
  PersonalInfo,
} from 'src/app/shared/interfaces/student';
import { StudentDetails } from 'src/app/shared/interfaces/student-details';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';

import { DialogCloseResult } from '@progress/kendo-angular-dialog';
import { ReferenceStore } from 'src/app/stores/reference.store';
import { StudentStore } from 'src/app/stores/student.store';
import { HeaderResponse } from '../dashboard/interface/dashboard-response';
import { FormattedDates } from '../dashboard/interface/formatted-dates.';
import { iepSections } from '../iep/iep-document/constants/iep-sections';
import { IepSubmitEligibilityRequest } from '../iep/iep-document/models/iep-eligibilty-models/iep-submit-eligibility.model';
import { IEPService } from '../iep/iep-document/services/iep.services';
import { ReferralType } from '../referrals/interfaces/referrals.model';
import { AdminService } from '../administration/services/admin.service';
import {
  dialogAnimationDuration,
  dialogTimer,
} from 'src/app/shared/constants/dialog-specs';
@Component({
  selector: 'app-student-info',
  templateUrl: './student-info.component.html',
  styleUrls: ['./student-info.component.scss'],
  standalone: false,
})
export class StudentInfoComponent implements OnDestroy, OnInit, OnChanges {
  public actionsList: ActionsResponse;
  @Input() studentDetails: StudentDetails;
  @Input() showLoader: boolean = true;
  @Input() showParentInfo: boolean = false;
  @Input() showEditIcon: boolean = false;
  @Input() showEIInfo: boolean = false;
  @Input() rfd: boolean;
  @Input() showLoadingSpinner: boolean = true;
  @Output() submitEdit: EventEmitter<PersonalInfo> =
    new EventEmitter<PersonalInfo>();
  @Output() emitRefSk: EventEmitter<string> = new EventEmitter<string>();
  @Output() loaded: EventEmitter<void> = new EventEmitter<void>();
  @Output() rfdSaved: EventEmitter<void> = new EventEmitter<void>();
  public popupRef: PopupRef;
  magnifyingGlass: SVGIcon = this.customFaIcon(faMagnifyingGlassChart);
  fileSignature: SVGIcon = this.customFaIcon(faFileSignature);
  graduationCap: SVGIcon = this.customFaIcon(faGraduationCap);
  userNurse: SVGIcon = this.customFaIcon(faUserNurse);
  checkToSlot: SVGIcon = this.customFaIcon(faCheckToSlot);
  square: SVGIcon = this.customFaIcon(faSquare);
  hand: SVGIcon = this.customFaIcon(faHand);
  addressBook: SVGIcon = this.customFaIcon(faAddressBook as IconDefinition);
  copy: SVGIcon = this.customFaIcon(faCopy as IconDefinition);
  location: SVGIcon = this.customFaIcon(faLocationDot);
  circleExclamation: IconDefinition = faCircleExclamation;
  showEditStudentProfileDialog: boolean;
  parentIconExpanded: boolean = false;
  editMode: boolean = false;
  editPersonalDetail: boolean = false;
  hideSecondaryParent: boolean = true;
  personalDetailForm: FormGroup;
  states?: DropdownOption[];
  languages?: DropdownOption[];
  relationships?: DropdownOption[];
  @Input() studentOSISId$: string;
  selectedValue: string;
  parentInfo: ParentInfo;
  personalInfo: PersonalInfo;
  primaryParent: ParentsInfo;
  secondaryParent: ParentsInfo;
  public editIcon: SVGIcon = pencilIcon;
  studentInformationForm: FormGroup;
  showIcon: boolean;
  studentData: HeaderResponse;
  complianceDatesArray: FormattedDates[];
  dueDatesArray: FormattedDates[];
  caseProcess: {
    icon: IconProp;
    label: string;
  };
  steps: { label: string }[] = [];
  @Input() showAction: boolean;
  loadSpinner: boolean = true;
  @ViewChild('container', { read: ViewContainerRef })
  public container: ViewContainerRef;
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
  showAmendDialog$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  showAnnualDialog$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  showRemoveMDEDialog$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  showScheduleMeetingDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showCancelMeetingDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showCloseRequestForReevaluationDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showCaseClosingEventsDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showCaptureFirstAttendDate$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showReAssign$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showUpload$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  referralSk: string;
  caseStage: string;
  meetingType: MeetingType;
  meetingSk: string;
  isViewMode: boolean;
  actionText: string;
  meetingRoster: MeetingRole[];
  isReAssign: boolean;
  showDialog: boolean = true;
  isCreatingIep: boolean = false;
  nycId: string;
  studentSk: string;
  studentNycId: string;
  public user: User;
  basicStudentData: StudentDetails;
  xIcon: SVGIcon = xIcon;
  tooltipText: string;
  selectedIepSk: string;
  selectedStudentSK: string;
  loading: { actions: boolean; assign: boolean } = {
    actions: false,
    assign: false,
  };
  pwn: ReferralType;
  readonly primaryParentIndex: number = 0;
  readonly secondaryParentIndex: number = 1;
  readonly minParentsRequired: number = 1;
  readonly tooltipResetDelayMs: number = 3000;
  readonly indexZero: number = 0;
  readonly indexOne: number = 1;
  readonly indexTwo: number = 2;
  readonly oneDay: number = 1;

  readonly dayLeftLabel: string = 'Day Left';
  readonly daysLeftLabel: string = 'Days Left';
  readonly dayLabel: string = 'Day';
  readonly daysLabel: string = 'Days';

  showRfdDialog$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  faTriangleExclamation: IconDefinition = faTriangleExclamation;

  constructor(
    private fb: FormBuilder,
    private routesConstantService: RoutesConstantService,
    public studentStore: StudentStore,
    private router: Router,
    private popupService: PopupService,
    private dashboardService: DashboardService,
    private route: ActivatedRoute,
    public studentService: StudentService,
    private referenceStore: ReferenceStore,
    library: FaIconLibrary,
    private clipboard: Clipboard,
    public authStore: AuthStore,
    private cdRef: ChangeDetectorRef,
    private iepService: IEPService<any>,
    private notificationService: NotificationService,
    private adminService: AdminService,
  ) {
    library.addIcons(
      faUserGraduate,
      faSchool,
      faAddressCard,
      faChevronUp,
      faChevronDown,
      faSuitcaseMedical,
      faHouseUser,
      faFilePen,
      faNotesMedical,
      faBus,
      faUniversalAccess,
      faFile,
      faUsers,
      faBookOpenReader,
      faUsersBetweenLines,
      faLanguage,
      faEnvelope,
      faLocationDot,
      faCheck,
      faPen,
      faEdit,
      faBusinessTime,
      faTriangleExclamation,
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.details) {
      this.steps = _.map(this.studentData?.timeline, (item: string) => ({
        label: item,
      }));
    }
    if (changes.studentDetails && this.studentDetails?.nycId) {
      this.getDashboardDetails(this.studentDetails?.nycId);
    }
  }
  ngOnInit(): void {
    this.studentNycId = this.route.snapshot.paramMap.get('nycid');
    combineLatest([
      this.referenceStore.state$,
      this.referenceStore.language$,
      this.referenceStore.relationship$,
    ]).subscribe(
      (response: [DropdownOption[], DropdownOption[], DropdownOption[]]) => {
        this.states = [...response[this.indexZero]];
        this.languages = [...response[this.indexOne]];
        this.relationships = [...response[this.indexTwo]];
      },
    );
    let studentId: string;
    if (this.route.snapshot.paramMap.get('nycId')) {
      studentId = this.route.snapshot.paramMap.get('nycId');
      this.getDashboardDetails(studentId);
    } else if (
      this.route.snapshot.paramMap.get('id') &&
      this.router.url.includes('student')
    ) {
      studentId = this.route.snapshot.paramMap.get('id');
      this.getDashboardDetails(studentId);
    } else if (this.route.snapshot.paramMap.get('nycid')) {
      studentId = this.route.snapshot.paramMap.get('nycid');
      this.getDashboardDetails(studentId);
    } else if (this.studentDetails?.nycId) {
      studentId = this.studentDetails?.nycId;
      this.getDashboardDetails(studentId);
    } else if (this.studentOSISId$) {
      studentId = this.studentOSISId$;
      this.getDashboardDetails(studentId);
    }

    if (this.router.url.includes('student')) {
      this.showIcon = true;
    }

    this.authStore.UserInfo$.pipe(
      filter((user: User) => !!user),
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      take(1),
    ).subscribe((user: User) => {
      this.user = user;
      this.cdRef.detectChanges();
    });
  }

  get canEdit(): boolean {
    return this.user?.isGlobalUser && this.user?.isSupervisor;
  }

  getDashboardDetails(studentId: string): void {
    this.dashboardService
      .getStudentHeaderDetails(studentId)
      .subscribe((res: HeaderResponse[]) => {
        this.studentData = head(res);
        this.emitRefSk.emit(this.studentData?.referralSK);
        if (this.studentData) {
          if (this.studentDetails) {
            this.studentDetails.referralSK = this.studentData?.referralSK;
          }
          this.complianceDatesArray =
            this.getFormattedComplianceDueDates('complianceDates');
          this.dueDatesArray = this.getFormattedComplianceDueDates('dueDates');
        }
        this.loadSpinner = false;
        this.loaded.emit();
      });
  }

  getBasicStudentDetailsById(studentId: string): void {
    this.studentService
      .getBasicStudentDetailsById(studentId)
      .subscribe((res: StudentDetails) => {
        this.basicStudentData = res;
      });
  }

  loadActions(event: KeyboardEvent | MouseEvent): void {
    event?.stopPropagation();
    this.nycId = this.studentDetails?.nycId;
    this.studentSk = this.studentDetails?.studentSk;
    this.referralSk = this.studentData?.referralSK;
    this.loading = Object.assign({}, this.loading, { actions: true });

    this.dashboardService
      .getActionItems(this.studentDetails?.studentSk)
      .subscribe((res: ActionsResponse) => {
        this.actionsList = { ...res };
        this.loading = Object.assign({}, this.loading, { actions: false });
      });
  }

  displayRfdDialog(value: boolean): void {
    this.showRfdDialog$.next(value);
  }

  onRfdSaved(): void {
    this.rfdSaved.emit();
  }

  getCaseProcessAndIcon(): void {
    switch (this.studentData?.caseProcess) {
      case 'Eval':
      case 'Eval/IEP':
        this.caseProcess = {
          icon: 'magnifying-glass-chart',
          label: 'Evaluations',
        };
        break;
      case 'Referral':
        this.caseProcess = {
          icon: 'hand',
          label: 'Referrals',
        };
        break;
      case 'IEP':
        this.caseProcess = {
          icon: 'file-signature',
          label: 'IEP',
        };
        break;
      case 'Placement':
        this.caseProcess = {
          icon: 'graduation-cap',
          label: 'Placement',
        };
        break;
    }
  }

  openEditStudentProfileDialog(): void {
    this.showEditStudentProfileDialog = true;
  }

  getFormattedComplianceDueDates(date: string): FormattedDates[] {
    const keyValuePairs: string[] | undefined =
      this.studentData?.[date]?.split(',');
    const result: FormattedDates[] | undefined = keyValuePairs?.map(
      (pair: string) => {
        const [descr, date, days, referraltype]: string[] = pair.split('|');
        return { descr, date, days, referraltype };
      },
    );
    return result;
  }

  getDayLabel(days: string): string {
    const daysNumber: number = parseInt(days, 10);
    return Math.abs(daysNumber) === this.oneDay
      ? this.dayLeftLabel
      : this.daysLeftLabel;
  }

  getComplianceDayLabel(days: string): string {
    const daysNumber: number = parseInt(days, 10);
    return Math.abs(daysNumber) === this.oneDay
      ? this.dayLabel
      : this.daysLabel;
  }

  getReferralType(type: string): string {
    const typeNumber: number = parseInt(type, 10);
    return Math.abs(typeNumber) === 1 || Math.abs(typeNumber) === 3 ? 'Initial' : 'Reevaluation';
  }

  getActivityLabel(stage: string): string {
    return stage === 'Reevaluation' ? 'Initial' : stage === 'Additional Reeval' ? 'Reevaluation' : "Previous";
  } 

  formatPreviousActivity(activity: string): string[] {
    return (activity || '')
      .split(/(?=\bSummer\b)/gi)
      .map((part: string, index: number) => index === 0 ? part.trimEnd() : part.trimStart());
  }

  customFaIcon(icon: IconDefinition): SVGIcon {
    return {
      name: icon.iconName,
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      content: `<path d="${icon.icon[4]}" />`,
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      viewBox: `0 0 ${icon.icon[0]} ${icon.icon[1]}`,
    };
  }
  closeEditStudentProfileDialog(): void {
    this.showEditStudentProfileDialog = false;
  }
  public editStudentInfo(): void {
    this.editMode = true;
    // check if it already exists, which means edit was pressed. There is no reason to recreate the form once it's been created
    const form: UntypedFormGroup = this.fb.group({
      studentInformation: this.fb.group({
        firstName: [this.studentDetails.firstName, Validators.required],
        middleName: [this.studentDetails.middleName],
        lastName: [this.studentDetails.lastName, Validators.required],
        dateOfBirth: [
          new Date(this.studentDetails.dateOfBirth ?? new Date().getTime()), // TODO temporary hack
          Validators.required,
        ],
      }),
    });

    this.hideSecondaryParent =
      this.studentDetails?.parentDetails?.length < this.minParentsRequired;
    form.addControl(
      'primaryParent',
      this.createParentFormGroup(
        this.studentDetails?.parentDetails![this.primaryParentIndex],
      ),
    );
    form.addControl(
      'secondaryParent',
      this.createParentFormGroup(
        this.studentDetails?.parentDetails![this.secondaryParentIndex],
      ),
    );

    this.studentInformationForm = form;
  }

  private createParentFormGroup(parentInfo?: ParentsInfo): FormGroup {
    return this.fb.group({
      firstName: [parentInfo?.firstName, Validators.required],
      lastName: [parentInfo?.lastName, Validators.required],
      phoneNumber: [parentInfo?.homePhone],
      workPhone: [parentInfo?.workPhone],
      spokenLanguage: [
        this.mapReferenceData(this.languages, parentInfo?.preferredSpokenLang),
      ],
      writtenLanguage: [
        this.mapReferenceData(this.languages, parentInfo?.preferredWrittenLang),
      ],
      address1: [parentInfo?.address?.streetAddress1],
      address2: [parentInfo?.address?.streetAddress2],
      city: [parentInfo?.address?.city],
      state: [this.mapReferenceData(this.states, parentInfo?.address?.state)],
      zipCode: [parentInfo?.address?.zipCode],
      emailAddress: [parentInfo?.emailAddress],
      relationship: [
        this.mapReferenceData(this.relationships, parentInfo?.relationship),
        Validators.required,
      ],
    });
  }

  private mapReferenceData(data?: DropdownOption[], id?: number) {
    return data?.find((r: DropdownOption) => r.id === id);
  }

  expandParent(): void {
    this.parentIconExpanded = !this.parentIconExpanded;
  }

  get studentInformationFormGroup(): FormGroup {
    return this.studentInformationForm.get('studentInformation') as FormGroup;
  }

  get primaryParentFormGroup(): FormGroup {
    return this.studentInformationForm.get('primaryParent') as FormGroup;
  }

  get secondaryParentFormGroup(): FormGroup {
    return this.studentInformationForm.get('secondaryParent') as FormGroup;
  }

  submitEditedInfo(): void {
    const studentInfo: FormGroup = this.studentInformationFormGroup;
    const primaryParent: FormGroup = this.primaryParentFormGroup;

    const temp: PersonalInfo = {
      studentSk: this.studentDetails.studentSk,
      firstName: studentInfo?.get('firstName')?.value,
      middleName: studentInfo?.get('middleName')?.value,
      lastName: studentInfo?.get('lastName')?.value,
      birthDate: studentInfo?.get('dateOfBirth')?.value,
      deleteSecondaryContact: this.hideSecondaryParent,
      primaryParent: {
        parentSk: this.studentDetails?.parentDetails?.at(
          this.primaryParentIndex,
        )?.parentSk,
        isPrimary: true,
        ...this.parentToPayload(primaryParent),
      },
    };

    if (
      !this.hideSecondaryParent ||
      !!this.studentDetails?.parentDetails?.at(this.secondaryParentIndex)
    ) {
      temp.secondaryParent = {
        parentSk: this.studentDetails?.parentDetails?.at(
          this.secondaryParentIndex,
        )?.parentSk,
        isPrimary: false,
        ...this.parentToPayload(this.secondaryParentFormGroup),
      };
    }

    this.submitEdit.emit(temp);
    this.editMode = false;
  }
  routeToStudentProfile(studentDetails: StudentDetails): void {
    if (!this.router.url.includes('student')) {
      if (studentDetails?.nycId) {
        this.studentStore.initializeSelectedStudentId(studentDetails.nycId);
        this.router.navigate([
          this.routesConstantService.routes.studentInformationPage,
        ]);
      }
    }
  }
  // TODO use interfaces
  private parentToPayload(parent: FormGroup): ParentInfo {
    return {
      relationship: parent.get('relationship')?.value.id,
      firstName: parent.get('firstName')?.value,
      lastName: parent.get('lastName')?.value,
      homePhone: parent.get('phoneNumber')?.value,
      workPhone: parent.get('workPhone')?.value,
      spokenLanguage: parent.get('spokenLanguage')?.value?.id,
      writtenLanguage: parent.get('writtenLanguage')?.value?.id,
      email: parent.get('emailAddress')?.value,
      streetAddress1: parent.get('address1')?.value,
      streetAddress2: parent.get('address2')?.value,
      city: parent.get('city')?.value,
      state: parent.get('state')?.value?.id,
      zip: parent.get('zipCode')?.value,
    };
  }

  togglePopup(anchor: ElementRef | HTMLElement): void {
    if (this.popupRef) {
      this.closePopup();
    } else {
      this.loading.actions = true;
      this.getData(anchor);
    }
  }
  getData(anchor: ElementRef | HTMLElement): void {
    this.dashboardService
      .getActionItems(this.studentDetails?.studentSk)
      .subscribe((res: ActionsResponse) => {
        this.loading.actions = false;
        this.openPopup(anchor, res);
        this.popupRef.popupAnchorViewportLeave.subscribe(() => {
          this.closePopup();
        });
        this.popupRef.content.instance.popupRef = this.popupRef;
      });
  }
  openPopup(anchor: ElementRef | HTMLElement, res: ActionsResponse): void {
    this.popupRef = this.popupService.open({
      anchor: anchor,
      content: CustomActionsComponent,
      appendTo: this.container,
      anchorAlign: { horizontal: 'right', vertical: 'bottom' },
      popupAlign: { horizontal: 'right', vertical: 'top' },
    });
    this.popupRef.content.instance.actionsList = res;
    this.popupRef.content.instance.studentDetails = this.studentData;
  }
  closePopup(): void {
    if (this.popupRef) {
      this.popupRef.close();
      this.popupRef = null;
    }
  }
  isStudentSKValid(): boolean {
    return (
      this.studentData?.studentSK &&
      this.studentData?.studentSK !== '00000000-0000-0000-0000-000000000000'
    );
  }
  ngOnDestroy(): void {
    if (this.popupRef) {
      this.popupRef.close();
    }
  }

  copyClipboard(copiedText: string): void {
    this.clipboard.copy(copiedText);
    this.tooltipText = 'Copied';
    timer(this.tooltipResetDelayMs)
      .pipe()
      .subscribe(() => {
        this.tooltipText = 'Copy';
        this.tooltipDir?.hide();
      });
  }

  openAmendDialog(iepSk: string) {
    this.selectedIepSk = iepSk;
    this.showAmendDialog$.next(true);
  }

  onAmendDialogClose(result: { text: string } | DialogCloseResult): void {
    this.showAmendDialog$.next(false);

    if (result instanceof DialogCloseResult || result.text === 'No') {
      return;
    }

    if (result.text === 'Yes' && this.selectedIepSk) {
      const request: IepSubmitEligibilityRequest =
        new IepSubmitEligibilityRequest({
          referralSK: this.referralSk,
          iepFormSK: this.selectedIepSk,
          iepAmendment: true,
          lastModuser: this.user?.username,
        } as IepSubmitEligibilityRequest);

      this.iepService
        .amend(request, iepSections.eligibilty)
        .subscribe((data) => {
          if (data?.value?.iepFormSK) {
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
                this.nycId +
                '/' +
                data.value.iepFormSK +
                '/edit/eligibility',
            ]);
            this.closePopup();
          }
        });
    }
  }

  openAnnualDialog(iepSk: string) {
    this.selectedIepSk = iepSk;
    this.showAnnualDialog$.next(true);
  }

  onAnnualDialogClose(result: { text: string } | DialogCloseResult): void {
    this.showAnnualDialog$.next(false);

    if (result instanceof DialogCloseResult || result.text === 'No') {
      return;
    }

    if (result.text === 'Yes' && this.selectedIepSk) {
      const _iEligibilityRequestdata: IepSubmitEligibilityRequest =
        new IepSubmitEligibilityRequest({
          referralSK: this.referralSk,
          lastModuser: this.user?.username,
          iepMeetingType: 2,
          isAnnual: true,
          studentSK: this.studentDetails?.studentSk,
          referenceIEPFormsk: this.selectedIepSk,
        } as IepSubmitEligibilityRequest);
      this.iepService
        .submit(_iEligibilityRequestdata, iepSections.eligibilty)
        .subscribe((data) => {
          if (data) {
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
                this?.nycId +
                '/' +
                data?.value?.iepFormSK +
                '/edit/eligibility',
            ]);
            this.closePopup();
          }
        });
    }
  }

  openRemoveMDEWorklistDialog(studentSK: string): void {
    this.selectedStudentSK = studentSK;
    this.showRemoveMDEDialog$.next(true);
  }

  onRemoveMDEWorklistDialogClose(
    result: { text: string } | DialogCloseResult,
  ): void {
    this.showRemoveMDEDialog$.next(false);

    if (result instanceof DialogCloseResult || result.text === 'No') {
      return;
    }

    if (result.text === 'Yes' && this.selectedStudentSK) {
      this.removeFromWorklist();
    }
  }

  removeFromWorklist(): void {
    this.loadSpinner = true;
    this.adminService.removeFromWorklist(this.selectedStudentSK).subscribe({
      next: () => {
        this.notificationService.show({
          content: 'Submitted Successfully',
          cssClass: 'notification-success',
          hideAfter: dialogTimer,
          position: { horizontal: 'center', vertical: 'top' },
          animation: { type: 'slide', duration: dialogAnimationDuration },
          type: { style: 'success', icon: true },
        });
        this.loadSpinner = false;
        this.closePopup();
      },
      error: () => {
        this.loadSpinner = false;
      },
    });
  }
}
